export function newSubpackageObject() {
  this.subpackageTitle = null
  this.subpackageDescription = null
  this.subpackageTitleImageURL = null
  this.subpackagePrice = null
  this.subpackageTimeDuration = null
  this.subpackageTimeDuration = null
  this.selectedPackageForSubpackage = []
  this.selectedExtrasForSubpackage = []
  this.subpackagePriority = null
}